<template>
  <div v-if="show" class="card shadow-1">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    show: Boolean
  }
}
</script>
<style scoped>
  .card {
    /* height: 100%; */
    width: 100%;
  }
</style>
